import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function PerformanceChart({ data }) {
  return (
    <div className="wrapper-chart">
      <header>
        <h2>Performance </h2>
      </header>
      <ResponsiveContainer height={400}>
        <BarChart
          width="100%"
          height="100%"
          data={data}
          layout="horizontal"
          margin={{
            top: 0,
            right: 0,
            left: 0,
            bottom: 0,
          }}
          barSize={10}
        >
          <XAxis hide dataKey="title" padding={{ left: 10, right: 10 }} />

          <YAxis dataKey="score" hide />
          <Tooltip />

          <Bar
            dataKey="score"
            radius={[20, 20, 20, 20]}
            fill="#FF8F6B"
            background={{ fill: "rgb(255, 244, 240)" }}
          />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}

export default PerformanceChart;
